import * as React from 'react';
import PageHeader from '../../components/page-header';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import * as uuid from 'uuid';

const queryString = require('query-string');

import './index.styl';

import identityService, {
  PlayerIdentity,
} from '../../services/identity-service';

export type AppProps = RouteComponentProps<any> & InjectedTranslateProps;

export interface AppState {
  error?: String;
  userName: string;
  birthDate: string;
  govtId: string;
  providerType: string;
}

class MockIdentityInput extends React.Component<AppProps, AppState> {
  constructor(props) {
    super(props);

    this.state = {
      userName: '할머니',
      birthDate: '1982-04-07',
      govtId: uuid.v1(),
      providerType: 'MOBILE',
    };
  }

  valueChanged(e) {
    const target = e.target;

    if (target.id === 'user-name') {
      this.setState({
        userName: target.value,
      });
    }

    if (target.id === 'birth-date') {
      this.setState({
        birthDate: target.value,
      });
    }

    if (target.id === 'govt-id') {
      this.setState({
        govtId: target.value,
      });
    }

    if (target.id === 'provider-type') {
      this.setState({
        providerType: target.value,
      });
    }
  }

  submit(e: Event) {
    e.preventDefault();

    const search = queryString.parse(this.props.location.search);
    const playerIdentity: PlayerIdentity = {
      name: this.state.userName,
      birthDate: this.state.birthDate,
      govtId: this.state.govtId,
      serviceType: search.serviceType,
      providerType: this.state.providerType,
    };

    identityService
      .postMockPlayerIdentity(playerIdentity, search.callbackUrl)
      .then((resp) => {
        const message = {
          identityToken: resp.identityToken,
        };

        if (this._isIframe()) {
          window.parent.postMessage(message, '*');
        } else {
          if (this._isPopup()) {
            window.opener.postMessage(message, '*');
          } else {
            window.location.href = resp.landingUrl;
          }
        }
      });
  }

  _isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  _isPopup() {
    return window.opener;
  }

  render() {
    const { t } = this.props;
    return (
      <div className='container'>
        <PageHeader
          i18nHeader='self-auth-title'
          i18nSubHeader='self-auth-sub-title'
        />
        <section>
          <form
            action={`${
              process.env.IDENTITY_SERVER_URL
            }/internal/mock-identity-provider/v1/player-identities`}
            id='identity-form'
            className='mock-input'
            onSubmit={this.submit.bind(this)}>
            <div>
              <label className='input-label' htmlFor='user-name'>
                {t('mock-input-name')}:
              </label>
              <br />
              <input
                type='text'
                id='user-name'
                name='user-name'
                className='c-input'
                defaultValue={this.state.userName}
                onChange={this.valueChanged.bind(this)}
              />
            </div>
            <div>
              <label className='input-label' htmlFor='birth_date'>
                {t('mock-input-birth-date')}:
              </label>
              <br />
              <input
                type='text'
                id='birth-date'
                name='birth_date'
                className='c-input'
                defaultValue={this.state.birthDate}
                onChange={this.valueChanged.bind(this)}
              />
            </div>
            <div>
              <label className='input-label' htmlFor='govt-id'>
                {t('mock-input-govt-id')}:
              </label>
              <br />
              <input
                type='text'
                id='govt-id'
                name='govt-id'
                className='c-input'
                defaultValue={this.state.govtId}
                onChange={this.valueChanged.bind(this)}
              />
            </div>
            <div>
              <label className='input-label' htmlFor='provider-type'>
                {t('mock-provider-type')}:
              </label>
              <br />
              <select
                id='provider-type'
                name='provider-type'
                className='c-input'
                defaultValue={this.state.providerType}
                onChange={this.valueChanged.bind(this)}>
                <option>MOBILE</option>
                <option>IPIN</option>
              </select>
            </div>
            <div>
              <button type='submit' className='button large red'>
                {t('mock-input-submit')}
              </button>
            </div>
          </form>
        </section>
      </div>
    );
  }
}

export default compose(
  withRouter,
  translate(),
  connect()
)(MockIdentityInput);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/mock-input/index.tsx